"use client";
import React, { useCallback, useEffect, useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import { cn } from "@/lib/utils";

export const FlipWords = ({ words, duration = 3000, className }) => {
  const [index, setIndex] = useState(0);

  const startAnimation = useCallback(() => {
    setIndex((prev) => (prev + 1) % words.length);
  }, [words.length]);

  useEffect(() => {
    const timeout = setTimeout(startAnimation, duration);
    return () => clearTimeout(timeout);
  }, [index, duration, startAnimation]);

  const currentWord = words[index];
  const longestWord = words.reduce((a, b) => (a.length >= b.length ? a : b));

  return (
    <span className="relative inline-grid align-bottom">
      <span
        aria-hidden
        className={cn("invisible col-start-1 row-start-1 whitespace-nowrap font-bold", className)}
      >
        {longestWord}
      </span>
      <span className="col-start-1 row-start-1 overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.span
            key={currentWord}
            initial={{ opacity: 0, y: "100%" }}
            animate={{ opacity: 1, y: "0%" }}
            exit={{ opacity: 0, y: "-100%" }}
            transition={{ duration: 0.28, ease: "easeOut" }}
            className={cn("inline-block whitespace-nowrap font-bold", className)}
          >
            {currentWord}
          </motion.span>
        </AnimatePresence>
      </span>
    </span>
  );
};
